import React from 'react';
import './style.scss';

const SortableTableHeader = (props) => {
    const {name, value, activeSortDirection, activeSortValue, handleSelect} = props;
    return (
        <th onClick={() => handleSelect(value)}
            style={{cursor: 'pointer'}}
        >
            <div style={{border: 'none'}} className="d-flex align-items-center">
                <span className="mr-1">{name}</span>
                <i className={'fas ' +
                (activeSortValue === value ?
                    'sortable-header-icon--active ' +
                    (activeSortDirection === 'asc' ?
                        'fa-caret-up'
                        :
                        'fa-caret-down')
                    :
                    'fa-caret-down')
                }/>
            </div>
        </th>
    );
};

export default SortableTableHeader;
